import { render, staticRenderFns } from "./GroupMemberModal.vue?vue&type=template&id=bfd7266e"
import script from "./GroupMemberModal.vue?vue&type=script&lang=js"
export * from "./GroupMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports